import React from "react";
import { data } from "../../../data";

interface IWhyChooseBGVComponentProps {}

export const WhyChooseBGVComponent: React.FC<IWhyChooseBGVComponentProps> = (
    props: IWhyChooseBGVComponentProps
) => {
    const {whyChooseBgvs} = data
    return (
        <section id="features" className="features section">
            <div className="container">
                <div className="row gy-4">
                    <h4
                        className="mb-4"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        Make Safer Decisions Today Let BGV be your trusted
                        verification partner. Because when it comes to trust,
                        there’s no room for doubt.
                    </h4>
                    {whyChooseBgvs.map((data, index: number) => {
                        return (
                            <div
                                className="col-lg-6 features-item d-flex ps-0 ps-lg-3 pt-4 pt-lg-0 mb-4"
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                            >
                                <i
                                    className={`bi bi-${data.icon} flex-shrink-0`}
                                ></i>
                                <div>
                                    <h4>{data.title}</h4>
                                    <p>{data.description}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
